import React, { Component } from 'react';
import ActionEditorContainer from '../ActionEditorContainer';
import ActionRemoveFromListEditorComponent from './ActionRemoveFromListEditorComponent';

class ActionRemoveFromListEditorContainer extends Component {
  public render() {
    return <ActionEditorContainer editor={<ActionRemoveFromListEditorComponent />} type='remove-from-list' icon='remove_notes' />;
  }
}

export default ActionRemoveFromListEditorContainer;
